import { Sort } from "@planzone/dto";

type GanttSort = Sort | "zone";

export type { GanttSort };
